import React from "react";
import { XCircle, Package } from "lucide-react";
import { NOT_COVERED, CLIENT_SUPPLIED_EXAMPLES } from "@/data/maintenancePlans";

export default function ExclusionsAndMaterialsSection() {
  return (
    <section className="section-pad bg-br-paper" id="exclusions" data-testid="exclusions">
      <div className="container-br grid lg:grid-cols-2 gap-5">
        <div className="bg-white border border-gray-200 rounded p-6" data-testid="not-included-card">
          <div className="flex items-start gap-3 mb-3">
            <XCircle size={24} className="text-red-500 shrink-0 mt-1" />
            <div>
              <div className="br-eyebrow text-br-bronze">Exclusions</div>
              <h2 className="br-headline text-2xl sm:text-3xl mt-1">What Maintenance Memberships Do Not Include</h2>
            </div>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed mb-3">
            To keep the plans clear and sustainable, maintenance memberships do not include unlimited repair labor or major trade work.
          </p>
          <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-1 text-sm text-gray-700">
            {NOT_COVERED.map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="text-red-500 mt-1 leading-none">×</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-white border border-gray-200 rounded p-6" data-testid="client-supplied-card">
          <div className="flex items-start gap-3 mb-3">
            <Package size={24} className="text-br-bronze shrink-0 mt-1" />
            <div>
              <div className="br-eyebrow text-br-bronze">Materials</div>
              <h2 className="br-headline text-2xl sm:text-3xl mt-1">Client-Supplied Routine Materials</h2>
            </div>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed mb-3">
            For routine maintenance tasks, homeowners are responsible for providing standard replacement materials unless a separate quote says otherwise.
          </p>
          <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-1 text-sm text-gray-700">
            {CLIENT_SUPPLIED_EXAMPLES.map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="text-br-bronze mt-1 leading-none">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <p className="mt-3 text-xs text-gray-500 italic">
            If materials are not available at the visit, Black Ridge may document the task as deferred and continue with the rest of the checklist.
          </p>
        </div>
      </div>
    </section>
  );
}
